import one from '@mailobj-browser/front/js/selectors/one.js'
import * as utilities from '#utilities/js/styles.js'
import { elements } from '../../../styles.js'

export default container => {
  const buttonJoin = one(`.${elements.join}`)
  const buttonCall = one(`.${elements.call}`)
  if (buttonJoin) {
    buttonJoin.setAttribute('data-id', '')
    buttonJoin.classList.add(utilities.modifiers.display.none)
  }
  if (buttonCall) {
    buttonCall.classList.remove(utilities.modifiers.display.none)
  }
}
